import React from 'react';
import PropTypes from 'prop-types';
import './svg.css';


const LogOutIcon = props => {
  const { fill, className } = props;
  return (
    <svg
      viewBox="10 5 10 20"
      height="18px"
      width="18px"
      className="p-t-2 p-l-2"
    >
      <path d="M23,20 C23,22.7614237 20.7614237,25 18,25 L10,25 C7.23857625,25 5,22.7614237 5,20 L5,12 C5,9.23857625 7.23857625,7 10,7 L18,7 C20.7614237,7 23,9.23857625 23,12 L23,14.0982715 C23,13.9667144 22.8880298,13.8599359 22.7500761,13.8599359 L16.5021672,13.8599359 L16.5021672,11.2383335 C16.5021672,11.1420563 16.4411799,11.0552974 16.3482111,11.0181182 C16.2547504,10.9814083 16.1472786,11.0014278 16.0757949,11.0695971 L11.0734753,15.8242441 C11.0264989,15.8690424 11,15.9295926 11,15.9929805 C11,16.0563683 11.0264989,16.1169186 11.0729833,16.1617168 L16.0753028,20.9301943 C16.1468101,20.9983636 16.2542583,21.0188524 16.3477426,20.9816732 C16.4412033,20.944494 16.5021907,20.8577351 16.5021907,20.761458 L16.5021907,18.1498653 L22.7500761,18.1498653 C22.8880298,18.1498653 23,18.0430869 23,17.9115297 L23,20 Z" id="Combined-Shape" id="Combined-Shape" fill={fill ? fill : "#FE4242"}></path>
    </svg>
  );
};

// LogOutIcon.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default LogOutIcon;
